import { Tier, TIERS } from '@backrs_ui/common-ui';

import { Svg, StyleSheet } from '@react-pdf/renderer';

import { EntrepreneurshipBox } from './EntrepreneurshipBox';
import { Lines } from './Lines';
import { MiddleTierBox } from './MiddleTierBox';
import { SemiSkilledBox } from './SemiSkilledBox';
import { TopTierBox } from './TopTierBox';
import { TradeBox } from './TradeBox';
import { UpperTierBox } from './UpperTierBox';

type CareerPathDiagramPDFProps = Readonly<{
  minimumTrack: Tier;
  entrepreneurshipRecommended: boolean;
}>;

export function CareerPathDiagramPDF({
  minimumTrack,
  entrepreneurshipRecommended,
}: CareerPathDiagramPDFProps) {
  const tierOrder: Tier[] = [TIERS.SEMISKILLED, TIERS.TRADE, TIERS.MID, TIERS.UPPER, TIERS.TOP];

  const minimumIndex = tierOrder.indexOf(minimumTrack);

  const isAboveOrEqualMinimum = (track: Tier) => tierOrder.indexOf(track) >= minimumIndex;

  return (
    <Svg viewBox="0 0 677 400" height={400} width={677} style={styles.svgContainer}>
      <Lines
        semiSkilledToTradesTechnical={isAboveOrEqualMinimum(TIERS.TRADE)}
        semiSkilledToMiddleTier={isAboveOrEqualMinimum(TIERS.MID)}
        semiSkilledToUpperTier={isAboveOrEqualMinimum(TIERS.UPPER)}
        semiSkilledToTopTier={isAboveOrEqualMinimum(TIERS.TOP)}
        entrepreneurshipToTradesTechnical={
          entrepreneurshipRecommended && isAboveOrEqualMinimum(TIERS.TRADE)
        }
        entrepreneurshipToMiddleTier={
          entrepreneurshipRecommended && isAboveOrEqualMinimum(TIERS.MID)
        }
        entrepreneurshipToUpperTier={
          entrepreneurshipRecommended && isAboveOrEqualMinimum(TIERS.UPPER)
        }
        entrepreneurshipToTopTier={entrepreneurshipRecommended && isAboveOrEqualMinimum(TIERS.TOP)}
      />
      <SemiSkilledBox isHighlighted={minimumTrack === TIERS.SEMISKILLED} />
      <EntrepreneurshipBox isHighlighted={entrepreneurshipRecommended} />
      <MiddleTierBox isHighlighted={isAboveOrEqualMinimum(TIERS.MID)} />
      <UpperTierBox isHighlighted={isAboveOrEqualMinimum(TIERS.UPPER)} />
      <TopTierBox isHighlighted={isAboveOrEqualMinimum(TIERS.TOP)} />
      <TradeBox isHighlighted={isAboveOrEqualMinimum(TIERS.TRADE)} />
    </Svg>
  );
}

const styles = StyleSheet.create({
  svgContainer: {
    position: 'absolute',
    top: -90,
    width: '70%',
    right: 8,
  },
});
